import React from 'react'
import { Box, type BoxProps } from '@mui/material'

export interface PageWrapperProps extends BoxProps {
  children: React.ReactNode
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ children, sx, ...rest }) => {
  const defaultSx = {
    minHeight: '100vh',
    width: '100%',
    boxSizing: 'border-box' as const,
    padding: '24px',
    paddingBottom: {
      xs: 'calc(32px + env(safe-area-inset-bottom, 0px))',
      sm: 'calc(24px + env(safe-area-inset-bottom, 0px))'
    },
    '@media (min-width:1400px)': {
      padding: '60px',
      paddingBottom: '60px'
    }
  }

  const additionalSx = Array.isArray(sx) ? sx : sx ? [sx] : []

  return (
    <Box sx={[defaultSx, ...additionalSx]} {...rest}>
      {children}
    </Box>
  )
}

export default PageWrapper
